import fetchContacts from './fetchContacts';
import fetchProjects from './fetchProjects';
import fetchProposals from './fetchProposals';

export default (q, branchOfficeId) => (dispatch) => {
    if (!q) return;

    let promises = [];

    promises.push(dispatch(fetchContacts(q, 1, branchOfficeId)));

    promises.push(dispatch(fetchProjects(q, 1, branchOfficeId)));

    promises.push(dispatch(fetchProposals(q, 1, branchOfficeId)));
};
